import React from "react";
import DeleteSpecificMedia from "../common/DeleteSpecificMedia";

export default function MediaThumbnail({ isLoading, src, type, alt, onLoad }) {
  const isVideo = type === "videos";

  return (
    <div className="relative">
      <div
        className={`h-[400px] w-full max-w-[350px] animate-pulse rounded-md bg-gray-200 ${isLoading ? "block" : "hidden"}`}
      />

      {isVideo ? (
        <video
          src={src}
          className={`h-[400px] w-[350px] rounded-md ${isLoading ? "hidden" : "block"}`}
          controls
          onLoadedData={onLoad}
        />
      ) : (
        <img
          src={src}
          alt={alt || "Media Thumbnail"}
          className={`h-[400px] w-[350px] rounded-md ${isLoading ? "hidden" : "block"}`}
          onLoad={onLoad}
        />
      )}
    </div>
  );
}
